module.exports = __webpack_public_path__ + "media/images/admin/icons/eye-off-9b252ac3c64df27e39dcfd7066115c87.svg";